var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.34 166.667H273.34C236.003 166.667 217.321 166.667 203.06 173.933C190.516 180.324 180.324 190.516 173.933 203.06C166.667 217.321 166.667 236.003 166.667 273.34V526.673C166.667 564.01 166.667 582.67 173.933 596.93C180.324 609.473 190.516 619.683 203.06 626.073C217.307 633.333 235.966 633.333 273.23 633.333H526.77C564.033 633.333 582.666 633.333 596.913 626.073C609.456 619.683 619.683 609.463 626.073 596.92C633.333 582.674 633.333 564.033 633.333 526.77V466.667M614.5 366.667H433.333M666.666 133.333L433.333 366.667M433.333 198V366.667",
    stroke: "white",
    strokeWidth: 66.6667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalLink);
export default __webpack_public_path__ + "static/media/internal_link.bc5389496cbb393a792d77ee05aac517.svg";
export { ForwardRef as ReactComponent };